"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ReactCanvas;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _react = require("react");
const _View = /*#__PURE__*/ _interop_require_default(require("../View"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ReactCanvas({ // configuration -->
config = {}, container = "container", width = 640, height = 480, // payload -->
images = {}, shapes = [], // properties -->
rotation = 0, isMarkerLayerVisible = true, interactive = true, activeDrawingShape = "", // event callbacks -->
onShapeUpdate = ()=>{}, onCursorUpdate = ()=>{}, onSave = ()=>{} }) {
    const { scale: canvasScale = 1, visible = true } = config;
    const { preview, vl, ir } = images;
    const canvasRef = (0, _react.useRef)();
    const handleKeyDown = (e)=>{
        if (canvasRef.current) {
            canvasRef.current.handleKeyDown(e);
        }
    };
    // bindings --->
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.onShapeUpdate = onShapeUpdate;
        }
    }, [
        onShapeUpdate
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.onCursorUpdate = onCursorUpdate;
        }
    }, [
        onCursorUpdate
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.onSave = onSave;
        }
    }, [
        onSave
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.setInteractive(interactive);
        }
    }, [
        interactive
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.setHidden(!visible);
        }
    }, [
        visible
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.updateImageIR(ir, vl);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ir,
        vl,
        width,
        height
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.updateImageVL(vl);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        vl,
        width,
        height
    ]);
    (0, _react.useEffect)((preview, ir)=>{
        if (canvasRef.current) {
            canvasRef.current.updateImagePreview(preview, ir, vl);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ir,
        vl,
        preview,
        width,
        height
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.setShapes(shapes);
        }
    }, [
        shapes
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.setRotation(rotation);
        }
    }, [
        rotation
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.setDrawingShape(activeDrawingShape);
        }
    }, [
        activeDrawingShape
    ]);
    (0, _react.useEffect)(()=>{
        if (canvasRef.current) {
            canvasRef.current.setShapeLayerVisible(isMarkerLayerVisible);
        }
    }, [
        isMarkerLayerVisible
    ]);
    (0, _react.useEffect)(()=>{
        const canvas = new _View.default({
            container,
            width,
            height,
            // properties -->
            rotation,
            interactive,
            activeDrawingShape,
            isMarkerLayerVisible,
            // event callbacks -->
            onShapeUpdate,
            onCursorUpdate,
            onSave
        });
        canvas.initializeStage();
        canvasRef.current = canvas;
        return ()=>{
            if (canvasRef.current) {
                canvasRef.current.destroyStage();
                canvasRef.current = null;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const styles = {
        container: {
            width: width * canvasScale,
            height: height * canvasScale,
            visibility: visible ? "visible" : "hidden",
            display: visible ? "block" : "none"
        },
        stage: {
            transform: `scale(${canvasScale})`,
            transformOrigin: "top left"
        }
    };
    return /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
        style: styles.container,
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
            tabIndex: "0",
            onKeyDown: handleKeyDown,
            style: styles.stage,
            children: /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                id: container
            })
        })
    });
}
